import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_995334456 from "../../../../../packages/component/src/components/upload/demo/demo1.js?loadDemo";
import legacyImportDemo_1986203323 from "../../../../../packages/component/src/components/upload/demo/demo2.js?loadDemo";
import legacyImportDemo_888634682 from "../../../../../packages/component/src/components/upload/demo/demo3.js?loadDemo";
import legacyImportDemo_4000200381 from "../../../../../packages/component/src/components/upload/demo/demo4.js?loadDemo";
import legacyImportDemo_69135676 from "../../../../../packages/component/src/components/upload/demo/demo5.js?loadDemo";
import legacyImportDemo_2112368831 from "../../../../../packages/component/src/components/upload/demo/demo6.js?loadDemo";
import legacyImportDemo_3503718206 from "../../../../../packages/component/src/components/upload/demo/demo7.js?loadDemo";
import legacyImportDemo_1452766385 from "../../../../../packages/component/src/components/upload/demo/demo8.js?loadDemo";
import legacyImportDemo_1432568112 from "../../../../../packages/component/src/components/upload/demo/demo9.js?loadDemo";
import legacyImportDemo_2989161928 from "../../../../../packages/component/src/components/upload/demo/demo10.js?loadDemo";
import legacyImportDemo_387531305 from "../../../../../packages/component/src/components/upload/demo/demo11.js?loadDemo";
import legacyImportDemo_2291712394 from "../../../../../packages/component/src/components/upload/demo/demo12.js?loadDemo";
import legacyImportDemo_739110891 from "../../../../../packages/component/src/components/upload/demo/demo13.js?loadDemo";
import legacyImportDemo_2540878668 from "../../../../../packages/component/src/components/upload/demo/demo14.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_995334456,
  legacyImportDemo_1986203323,
  legacyImportDemo_888634682,
  legacyImportDemo_4000200381,
  legacyImportDemo_69135676,
  legacyImportDemo_2112368831,
  legacyImportDemo_3503718206,
  legacyImportDemo_1452766385,
  legacyImportDemo_1432568112,
  legacyImportDemo_2989161928,
  legacyImportDemo_387531305,
  legacyImportDemo_2291712394,
  legacyImportDemo_739110891,
  legacyImportDemo_2540878668,
  React
};